import html2canvas from "html2canvas";
import { toast } from "sonner";
import { buildPagination } from "./mainFunctions";
import { getCurrentMode, tokensFor } from "../Styles/theme";

export const tierListFunctions = {
  //

  onDragEndGrid(props) {
    const { result, albums, artists, songs, listType, setGridState, gridState, setAlbums, setArtists, setSongs } = props;

    if (!result.destination) return; // No destination means no drop

    const { source, destination, draggableId } = result;
    const draggedId = parseInt(draggableId);
    let objItem = albums;

    let draggedItem = albums.find((album) => album.Id === draggedId);
    if (listType === "Artists") {
      objItem = artists;
      draggedItem = artists.find((artist) => artist.Id === draggedId);
    } else if (listType === "Songs") {
      objItem = songs;
      draggedItem = songs.find((song) => song.Id === draggedId);
    }
    if (source.droppableId === destination.droppableId && source.index === destination.index) return;
    if (source.droppableId === "albumList" && destination.droppableId !== "albumList") {
      // Moving from albumList to a grid slot
      const filteredItems = objItem.filter((item) => item.Id !== draggedId);
      const displacedItem = gridState[destination.droppableId];

      const updateList = displacedItem ? [...filteredItems, displacedItem] : filteredItems;

      if (listType === "Artists") {
        setArtists(updateList);
      } else if (listType === "Songs") {
        setSongs(updateList);
      } else {
        setAlbums(updateList);
      }

      setGridState({
        ...gridState,
        [destination.droppableId]: draggedItem,
      });

      this.postCommands.trackDailyUsage();
    } else if (destination.droppableId === "albumList" && source.droppableId !== "albumList") {
      const sourceItem = gridState[source.droppableId];
      const updatedList = sourceItem ? [...objItem, sourceItem] : objItem;

      setGridState({
        ...gridState,
        [source.droppableId]: null,
      });

      if (listType === "Artists") {
        setArtists(updatedList);
      } else if (listType === "Songs") {
        setSongs(updatedList);
      } else {
        setAlbums(updatedList);
      }
    } else if (source.droppableId === "albumList" && destination.droppableId === "albumList") {
      return;
    } else {
      // Moving between tiers
      draggedItem = gridState[source.droppableId];
      const destinationDrop = gridState[destination.droppableId];

      if (source.droppableId === destination.droppableId) {
        setGridState({ ...gridState, [source.droppableId]: destinationDrop });
      } else {
        setGridState({
          ...gridState,
          [source.droppableId]: destinationDrop,
          [destination.droppableId]: draggedItem,
        });
      }
    }
  },

  onDragEnd(props) {
    const { result, setAlbums, setArtists, setSongs, setTiers, artists, songs, listType, albums, tiers } = props;
    if (!result.destination) return;

    const { source, destination, draggableId } = result;
    const draggedId = parseInt(draggableId);
    let objItem = albums;

    let draggedItem = albums.find((album) => album.Id === draggedId);
    if (listType === "Artists") {
      objItem = artists;
      draggedItem = artists.find((artist) => artist.Id === draggedId);
    } else if (listType === "Songs") {
      objItem = songs;
      draggedItem = songs.find((song) => song.Id === draggedId);
    }
    if (source.droppableId === destination.droppableId && source.index === destination.index) return;
    if (source.droppableId === "albumList" && destination.droppableId !== "albumList") {
      // Moving from albumList to a tier
      const letFilter = objItem.filter((item) => item.Id !== draggedId);
      if (listType === "Artists") {
        setArtists(letFilter);
      } else if (listType === "Songs") {
        setSongs(letFilter);
      } else {
        setAlbums(letFilter);
      }

      const destinationObj = [...tiers[destination.droppableId]];
      destinationObj.splice(destination.index, 0, draggedItem);

      setTiers({
        ...tiers,
        [destination.droppableId]: destinationObj,
      });

      this.postCommands.trackDailyUsage();
    } else if (destination.droppableId === "albumList" && source.droppableId !== "albumList") {
      draggedItem = tiers[source.droppableId].filter((item) => item.Id === draggedId);
      setTiers({
        ...tiers,
        [source.droppableId]: tiers[source.droppableId].filter((item) => item.Id !== draggedId),
      });
      const updatedList = [...objItem, ...draggedItem];

      if (listType === "Artists") {
        setArtists(updatedList);
      } else if (listType === "Songs") {
        setSongs(updatedList);
      } else {
        setAlbums(updatedList);
      }
    } else if (source.droppableId === "albumList" && destination.droppableId === "albumList") {
      return;
    } else {
      // Moving between tiers
      draggedItem = tiers[source.droppableId].filter((item) => item.Id === draggedId);
      const sourceTier = [...tiers[source.droppableId]];
      const destTier = [...tiers[destination.droppableId]];
      sourceTier.splice(source.index, 1);
      if (source.droppableId === destination.droppableId) {
        sourceTier.splice(destination.index, 0, ...draggedItem);
        setTiers({ ...tiers, [source.droppableId]: sourceTier });
      } else {
        destTier.splice(destination.index, 0, ...draggedItem);
        setTiers({
          ...tiers,
          [source.droppableId]: sourceTier,
          [destination.droppableId]: destTier,
        });
      }
    }
  },

  displayPopup(popup) {
    this.setState({
      popup: popup,
    });
  },

  captureScreenshot(theme) {
    if (!this.state.isAuthenticated) {
      this.setState({ showSignInPrompt: true });
      return;
    }

    const tierListElement = document.getElementById("tierList");
    const tierBoxElement = document.getElementById("tierBox");

    if (!tierListElement || !tierBoxElement) {
      return;
    }

    const previousTierListStyles = {
      position: tierListElement.style.position,
      overflowY: tierListElement.style.overflowY,
      height: tierListElement.style.height,
    };
    const previousTierBoxStyles = {
      overflow: tierBoxElement.style.overflow,
      height: tierBoxElement.style.height,
    };

    tierListElement.style.position = tierListElement.style.position || "relative";
    tierListElement.style.overflowY = "visible";
    tierListElement.style.height = "auto";

    tierBoxElement.style.overflow = "visible";
    tierBoxElement.style.height = "auto";

    const watermarkOverlay = document.createElement("div");
    watermarkOverlay.innerText = "MusicTierList.com";
    watermarkOverlay.style.position = "absolute";
    watermarkOverlay.style.top = "0";
    watermarkOverlay.style.right = "0";
    watermarkOverlay.style.bottom = "0";
    watermarkOverlay.style.left = "0";
    watermarkOverlay.style.fontSize = "30px";
    // Burned into the exported PNG, so it has to contrast with whichever
    // theme the list is currently rendered in.
    watermarkOverlay.style.color =
      getCurrentMode() === "light" ? "rgba(35, 32, 28, 0.35)" : "rgba(255, 255, 255, 0.5)";
    watermarkOverlay.style.pointerEvents = "none";
    watermarkOverlay.style.zIndex = "9999";
    watermarkOverlay.style.display = "flex";
    watermarkOverlay.style.justifyContent = "center";
    watermarkOverlay.style.alignItems = "center";
    watermarkOverlay.id = "SiteWatermark";
    tierListElement.appendChild(watermarkOverlay);

    const resolvedBackground =
      theme?.palette?.background?.default &&
      !theme.palette.background.default.includes(" ")
        ? theme.palette.background.default
        : getComputedStyle(tierListElement).backgroundColor ||
          tokensFor(getCurrentMode())["page-bg"];

    const restoreLayout = () => {
      document.getElementById("SiteWatermark")?.remove();

      tierListElement.style.position = previousTierListStyles.position;
      tierListElement.style.overflowY = previousTierListStyles.overflowY;
      tierListElement.style.height = previousTierListStyles.height;

      tierBoxElement.style.overflow = previousTierBoxStyles.overflow;
      tierBoxElement.style.height = previousTierBoxStyles.height;
    };

    setTimeout(() => {
      html2canvas(tierListElement, {
        useCORS: true,
        logging: true,
        backgroundColor: resolvedBackground,
        ignoreElements: (element) => {
          return element.id === "screenshotButton" || element.id === "addTierButton";
        },
        scale: 1,
      })
        .then(async (canvas) => {
          const dataUrl = canvas.toDataURL("image/jpeg", 0.75); // 75% quality for good compression
          const updateCapture = await this.updateCommands.updateCaptures();
          if (updateCapture) {
            const postCapture = await this.postCommands.createCapture(dataUrl);
            if (postCapture && postCapture.success) {
              // Auto-publish to gallery
              try {
                const thumbnail = await this.basicFunctions.generateThumbnail(dataUrl);
                await this.postCommands.publishToGallery(postCapture.captureId, thumbnail);
              } catch (err) {
                console.error("Auto-publish failed:", err);
              }
              this.setState(
                {
                  popup: "capturePopup",
                  latestScreenshot: dataUrl,
                  latestCaptureId: postCapture.captureId,
                },
                () => {
                  this.mainFunctions.refetchProfile();
                }
              );
              toast.success(this.t("toast.screenshotCaptured"));
            }
          }
        })
        .catch((error) => {
          console.error("Failed to capture screenshot", error);
          toast.error(this.t("toast.screenshotFailed"));
        })
        .finally(() => {
          restoreLayout();
        });
    }, 100);
  },

  handleTierNameChange(nameProps) {
    const { index, event, tierNames, tiers, setTierNames, setTiers } = nameProps;
    const newNames = [...tierNames];
    const oldName = newNames[index];
    newNames[index] = event.target.value;
    setTierNames(newNames);

    const updatedTiers = { ...tiers };
    updatedTiers[event.target.value] = updatedTiers[oldName];
    delete updatedTiers[oldName];
    setTiers(updatedTiers);

    Object.keys(updatedTiers).forEach((tier) => {
      updatedTiers[tier] = updatedTiers[tier].map((album) => {
        if (album.Tier === oldName) {
          return { ...album, Tier: event.target.value };
        }
        return album;
      });
    });
    setTiers(updatedTiers);
  },

  async changeListType(newListType) {
    let photoType;
    if (newListType === "Artists") {
      photoType = "Artists";
    } else if (newListType === "Songs") {
      photoType = "Songs";
      if (this.state.songList.length === 0) {
        const PAGE_SIZE = 100;
        const response = await this.getCommands.getCommon(`getSongs?page=1&limit=${PAGE_SIZE}`);
        if (response?.items) {
          this.setState({
            songList: response.items,
            songPagination: buildPagination(response),
          });
        } else if (response && Array.isArray(response)) {
          this.setState({ songList: response });
        }
      }
    } else {
      photoType = "Albums";
    }
    this.setState({
      listType: newListType,
      photoType: photoType,
    });
  },
};
